import type { Location } from "@/sales-tools/rapport-building/useRapportBuildingStore";

export function getLocationString(location: Location) {
    return [location.city, location.state].filter(Boolean).join(", ");
}
